import React from 'react'
import OrderBookApproval from '../../../components/chancemng/obtainorder/OrderBookApproval'

const OrderBookApprovalContainer = ({approvalList}) => {
    return <OrderBookApproval approvalList={approvalList}/>
}

export default OrderBookApprovalContainer
